import { Component, NgIterable, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { VulnerableActivityEnum } from 'src/app/enums';
import { StringHelper } from 'src/app/helpers';
import { AuthenticationResponse, SubjectObligedBasic } from 'src/app/models';
import { UserInfo } from 'src/app/security/models/user-info';
import { SecurityHelperService } from 'src/app/security/services/security-helper.service';
import { SecurityService } from 'src/app/security/services/security.service';
import { AccountService, PermissionService, SubjectObligedService } from 'src/app/services';

@Component({
  selector: 'app-login-subject-obliged',
  templateUrl:'./login-subject-obliged.component.html',
  styleUrls: ['./login-subject-obliged.component.scss'],
})
export class LoginSubjectObligedComponent implements OnInit, OnDestroy {
  allSubjectObligeds: Array<SubjectObligedBasic> = [];
  subjectObligeds: Array<SubjectObligedBasic> = [];
  loading = false;
  searchTerm: string = '';

  userName = '';
  isCommitteeValue = false;
  groupName = '';
  carouselTile: NguCarouselConfig | null = null;

  canNavigateHome = false;

  private filterChanged = new Subject<string>();
  private filterSuscription: Subscription;

  constructor(
    private subjectObligedService: SubjectObligedService,
    private securityService: SecurityService,
    private accountService: AccountService,
    private permissionService: PermissionService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private securityHelperService: SecurityHelperService
  ) {}

  ngOnInit(): void {
    this.filterSuscription = this.filterChanged.pipe(debounceTime(500)).subscribe((filterValue) => {
      const filterText = filterValue.toLowerCase();
      this.subjectObligeds = [];
      setTimeout(() => {
        if (!filterText) {
          this.subjectObligeds = this.allSubjectObligeds;
          return;
        }

        this.subjectObligeds = this.allSubjectObligeds.filter((so) => {
          const soName = so.name ? so.name.toLowerCase() : '';
          const soVulnerableActivity = so.vulnerableActivity ? so.vulnerableActivity.toLowerCase() : '';

          return soName.includes(filterText) || soVulnerableActivity.includes(filterText);
        });
      }, 50);
    });

    this.getSubjectObligeds();
    this.accountService.getUserInfo().subscribe({
      next: (res: UserInfo) => {
        this.userName = res.name;
        this.groupName = res.companyName;
        this.canNavigateHome = res.isAuthenticated;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.filterSuscription) this.filterSuscription.unsubscribe();
  }

  private getSubjectObligeds() {
    this.loading = true;
    this.subjectObligedService.getSubjectObligedsBranchOffices().toPromise()
      .then((res: Array<SubjectObligedBasic>) => {
        this.subjectObligeds = res.filter(so => so.enableVehSite && (so.vulnerableActivityId === VulnerableActivityEnum.VEH && (!StringHelper.isNullOrEmpty(so.branchOfficeName) || so.isAdmin)));
        this.allSubjectObligeds = this.subjectObligeds;
        this.setupCarouselTiles();
      })
      .finally(() => (this.loading = false));
  }

  loginAsSubjectObliged(subjectObliged: SubjectObligedBasic) {
    if (subjectObliged.isSuspended || !subjectObliged.enableVehSite) return;

    this.securityService.loginAsSubjectObliged(subjectObliged.id, subjectObliged.branchOfficeId).subscribe((res: AuthenticationResponse) => {
      this.securityHelperService.subjectObligedId = subjectObliged.id;
      this.securityHelperService.token = res.token;
      
      this.securityService.hasJustLoggedIn = true;
      this.permissionService.getPermissions().subscribe(
        (res) => {
          this.securityHelperService.permissions = res;
          this.router.navigate(['/app/dashboard'], { relativeTo: this.activatedRoute });
        },
        (err) => {
          this.router.navigate(['/select'], { relativeTo: this.activatedRoute });
        },
      );
    });
  }

  goToAlddaMX() {
    window.open('https://aldda.mx', '_self');
  }

  goToAlddaAdmin() {
    window.open('https://admin.aldda.mx', '_blank');
  }

  onInputChange(event: any) {
    const filterValue = event.target.value;
    this.filterChanged.next(filterValue);
  }

  setupCarouselTiles() {
    const lgSize = this.subjectObligeds.length >= 4 ? 4 : this.subjectObligeds.length;
    this.carouselTile = {
      grid: { xs: 1, sm: 1, md: 3, lg: lgSize, all: 0 },
      slide: 1,
      speed: 250,
      point: {
        visible: false,
      },
      load: 2,
      velocity: 0,
      touch: false,

      easing: 'cubic-bezier(0, 0, 0.2, 1)',
    };
  }

  movePrev(carousel: NguCarousel<any>) {
    if (carousel.isFirst) return;

    carousel.moveTo(carousel.activePoint - 1);
  }

  moveNext(carousel: NguCarousel<any>) {
    if (carousel.isEnd) return;

    carousel.moveTo(carousel.activePoint + 1);
  }
}
